import { Box } from '@mui/material';
import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Dialog from '/@/components/dialog';
import InteractiveFieldOverlayList from '/@/components/field-overlay-list/interactive';
import FieldFrostRiskNotificationToggle from '/@/components/fields/field-frost-risk-notification-toggle';
import { _ } from '/@/locale';
import { deleteFieldFromAPI } from '/@/store/fields/apiProviders';
import { getSelectedFeature } from '/@/store/nav/selectors';
import { getAppInstance, getInternalProfileEnabled, getSessionCountry } from '/@/store/session/selectors';
import { isMobile } from '/@/utils';
import styles from './styles.module.css';

@connect((state) => ({
    appInstance: getAppInstance(state),
    internalProfileEnabled: getInternalProfileEnabled(state),
    selectedFeature: getSelectedFeature(state),
    country: getSessionCountry(state),
}))
@autobind
export default class FieldInfo extends Component {
    static propTypes = {
        field: PropTypes.shape({
            name: PropTypes.string.isRequired,
            location: PropTypes.string,
            altitude: PropTypes.number,
            mapValues: PropTypes.array,
            selected: PropTypes.bool,
            node: PropTypes.shape({
                zones: PropTypes.arrayOf(
                    PropTypes.shape({
                        type: PropTypes.string.isRequired,
                        name: PropTypes.object.isRequired,
                    })
                ),
            }),
        }),
        shouldCollapse: PropTypes.bool,
        padding: PropTypes.bool,
        onClick: PropTypes.func,
        onDelete: PropTypes.func,
        disabled: PropTypes.bool,
        view: PropTypes.string,
        showIconMap: PropTypes.bool,
        showMap: PropTypes.bool,
        onClickShowMap: PropTypes.func,
        showArrow: PropTypes.bool,
        edit: PropTypes.func,
        selectedField: PropTypes.any,
        hideOverlays: PropTypes.bool,
    };

    static defaultProps = {
        padding: true,
        showArrow: true,
        showCompleteInfo: true,
        hideOverlays: false,
    };

    static contextTypes = {
        print: PropTypes.bool,
    };

    state = {
        collapsible: false,
        showDeleteConfirmation: false,
        fieldName: '',
        disabled: true,
        showActionsMobile: false,
    };

    UNSAFE_componentWillMount() {
        this.configureCollapsible(this.props);
        this.setState({ fieldName: this.props.field.name });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.configureCollapsible(nextProps);
    }

    handleChange(val) {
        this.setState({ fieldName: val });
    }

    handleEdit(event) {
        event.stopPropagation();
        this.props.edit();
    }

    renderShowMap() {
        return (
            <Fragment>
                {isMobile() && (
                    <i onClick={this.props.onClickShowMap} className='material-icons'>
                        {this.props.showMap ? 'location_off' : 'location_on'}
                    </i>
                )}
            </Fragment>
        );
    }

    renderInfo() {
        const {
            field,
            padding,
            onClick,
            onDelete,
            appInstance,
            internalProfileEnabled,
            disabled,
            disabledErrorMessage,
        } = this.props;
        const { collapsible } = this.state;
        const rootClassNames = classNames(
            styles.root,
            this.props.selected && styles.selected,
            padding && styles.padding,
            (onClick || collapsible) && styles.clickable,
            disabled && styles.disabled,
            this.props.view === 'weatherPhone' && styles.weather,
            this.props.view === 'sidebar' && styles.sidebar
        );

        return (
            <div className={rootClassNames} onClick={this.handleClick}>
                {disabled && <div className={styles.disabledLabel}>{disabledErrorMessage}</div>}
                <div className={styles.header}>
                    <div>
                        <div className={styles.label}>{_('Lote')}</div>
                        <div className={`${styles.fieldData} mp-mask`}>{field.name}</div>
                    </div>
                    <div className={styles.icons}>
                        {collapsible && (
                            <i className='material-icons'>
                                {this.state.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}
                            </i>
                        )}
                        {onClick && this.props.showArrow && <i className='material-icons'>chevron_right</i>}
                        <div className={styles.icon}>{this.props.showIconMap && this.renderShowMap()}</div>
                    </div>
                </div>
                {!this.state.collapsed && (
                    <Fragment>
                        {field.location && (
                            <div>
                                <div className={styles.label}>{_('Ubicación')}</div>
                                <div className={styles.fieldData}>{field.location}</div>
                            </div>
                        )}
                        {!this.context.print && (
                            <div>
                                <FieldFrostRiskNotificationToggle field={field} />
                            </div>
                        )}
                        {!this.context.print &&
                            this.props.view !== 'weatherPhone' &&
                            this.props.selectedFeature.view !== 'Home' &&
                            (appInstance.showFieldZonesAndAltitudes || internalProfileEnabled) &&
                            field.altitude && (
                                <div>
                                    <div className={styles.label}>{_('Altitud')}</div>
                                    {Math.round(field.altitude)} m
                                </div>
                            )}
                        {this.props.children}
                        {!this.props.hideOverlays && this.renderOverlays()}
                    </Fragment>
                )}
                {onDelete && (
                    <Dialog
                        title={_('Eliminar lote')}
                        message={`${_('Estás seguro de que querés eliminar el lote')} "${field.name}"? ${_(
                            'Eliminando el lote se eliminarán todas las recomendaciones asociadas al mismo.'
                        )}`}
                        visible={this.state.showDeleteConfirmation}
                        onClose={this.handleDeleteCancel}
                        onCancel={this.handleDeleteCancel}
                        onAccept={this.handleDeleteAccept}
                        alignCenter
                    />
                )}
            </div>
        );
    }

    renderActions() {
        const { field, selectedField } = this.props;
        const isSelected = field.id === selectedField.id;
        return (
            <Box sx={isSelected && { background: (t) => t.palette.primary[100] }}>
                <div className={styles.fieldDetailView} onClick={this.props.showActions}>
                    <div className={styles.info}>
                        <div>
                            <div className={styles.label}>{_('Lote')}</div>
                            <div className={`${styles.fieldData} mp-mask`}>{field.name}</div>
                        </div>
                        {field.location && (
                            <div>
                                <div className={styles.label}>{_('Ubicación')}</div>
                                <div className={styles.fieldData}>{field.location}</div>
                            </div>
                        )}
                        {!this.context.print && (
                            <div>
                                <FieldFrostRiskNotificationToggle field={field} />
                            </div>
                        )}
                    </div>
                    {this.props.selectedFeature.selectedFeature === 'FieldDetail' && isMobile() ? (
                        !this.state.showActionsMobile && (
                            <div className={classNames(styles.icons, styles.arrowRight)}>
                                <i className='material-icons'>chevron_right</i>
                            </div>
                        )
                    ) : (
                        <div className={styles.icons}>
                            <div className={styles.moreInfoIcon} onClick={() => this.props.showActions()}>
                                <span className='material-icons'>chevron_right</span>
                            </div>
                        </div>
                    )}
                    <Dialog
                        title={_('Eliminar lote')}
                        message={`${_('Estás seguro de que querés eliminar el lote')} "${field.name}"?`}
                        visible={this.state.showDeleteConfirmation}
                        onClose={this.handleDeleteCancel}
                        onCancel={this.handleDeleteCancel}
                        onAccept={this.handleDeleteAccept}
                        alignCenter
                    />
                </div>
                {this.state.showActionsMobile && (
                    <div className={styles.actionsMobile}>
                        <div onClick={(e) => this.handleEdit(e)} className={styles.editIcon} on>
                            <span className='material-icons'>drive_file_rename_outline</span>
                        </div>
                        <div className={styles.deleteIcon} onClick={this.handleDelete}>
                            <span className='material-icons'>delete_outline</span>
                        </div>
                        <div className={styles.closeIcon} onClick={() => this.setState({ showActionsMobile: false })}>
                            <span className='material-icons'>close</span>
                        </div>
                    </div>
                )}
                <Dialog
                    title={_('Eliminar lote')}
                    message={`${_('Estás seguro de que querés eliminar el lote')} "${field.name}"? ${_(
                        'Eliminando el lote se eliminarán todas las recomendaciones asociadas al mismo.'
                    )}`}
                    visible={this.state.showDeleteConfirmation}
                    onClose={this.handleDeleteCancel}
                    onCancel={this.handleDeleteCancel}
                    onAccept={this.handleDeleteAccept}
                    alignCenter
                />
            </Box>
        );
    }

    renderOverlays() {
        return <InteractiveFieldOverlayList field={this.props.field} />;
    }

    handleClick() {
        if (this.state.collapsible) this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
        if (this.props.onClick) this.props.onClick();
    }

    handleDelete(event) {
        event.stopPropagation();
        this.setState({ showDeleteConfirmation: true });
    }

    handleDeleteCancel() {
        this.setState({ showDeleteConfirmation: false });
    }

    handleDeleteAccept() {
        if (this.props.selectedFeature.selectedFeature === 'FieldDetail') {
            deleteFieldFromAPI({ fieldId: this.props.field.id, country: this.props.country.code });
            this.props.handleDelete();
        } else {
            this.props.onDelete();
        }
    }

    configureCollapsible({ shouldCollapse }) {
        if (shouldCollapse) {
            const collapse = !!isMobile();
            this.setState({ collapsible: collapse, collapsed: collapse });
        }
    }

    render() {
        return <Fragment>{this.props.view !== 'Home' ? this.renderInfo() : this.renderActions()}</Fragment>;
    }
}
